import { z } from 'zod';

/**
 * The legacy portal's inventory lookup: `/api/v1/listings/search_listings` on
 * the Rails monolith, called with `offerable=true&limit=5` from the third
 * character (`ListingTypeAheadInput` in consumer-legacy). The browser calls our
 * own `/api/make-offer/search-listings` proxy — the Rails API sets no CORS
 * headers for the Cosmos origin — and both sides parse with this schema.
 */
const listingSuggestionSchema = z.object({
  readable_address: z.string(),
  slug: z.string(),
});

export const listingSuggestionsSchema = z.array(listingSuggestionSchema);

export type ListingSuggestion = z.infer<typeof listingSuggestionSchema>;

export const MIN_QUERY_LENGTH = 3;
/**
 * Generous for any real address. The Rails scope feeds the query to a
 * pg_search trigram + tsearch lookup with no cap of its own, which gets
 * CPU-costly on pathological inputs.
 */
export const MAX_QUERY_LENGTH = 120;
export const SUGGESTION_LIMIT = 5;

export const searchListings = async (
  query: string,
  signal: AbortSignal,
): Promise<ListingSuggestion[]> => {
  const response = await fetch(
    `/api/make-offer/search-listings?query=${encodeURIComponent(query)}`,
    { signal },
  );
  if (!response.ok) {
    throw new Error(`listing search failed: ${response.status}`);
  }
  return listingSuggestionsSchema.parse(await response.json());
};
